import { apiService } from "../store";
import axios from "axios";
import { typeGroupsRequest, stateTrainingChildren } from "./selects";
import { statusChildren } from "./child";
import { invoiceState } from "./invoice";
import {
  fetchDiscountClient,
  getSourcesClient,
  getStatusClient,
} from "./client";
import { stateSchedule } from "./index";

export const loginError = (data) => {
  return {
    type: "LOGIN_ERROR",
    payload: data,
  };
};
export const messageErrorPassword = (data) => {
  return {
    type: "ERROR_PASSWORD",
    payload: data,
  };
};
export const firstLogin = (data) => {
  return {
    type: "LOGIN_FIRST_LOAD",
    payload: data,
  };
};
export const loadingUnpaid = (bool) => {
  return {
    type: "LOADING_UNPAID",
    payload: bool,
  };
};
export const signIn = (credentials, doInit) => (dispatch) => {
  dispatch(setLoading(true));
  apiService
    .login(credentials)
    .then((response) => {
      axios.defaults.headers.common = {
        Authorization: `Bearer ${response.token}`,
      };
      localStorage.setItem("token", response.token);
      dispatch(setAuthenticated(true));
      dispatch(firstLogin(true));
      dispatch(loginError(null));
    })
    .then(() => {
      dispatch(doInit());
    })
    .catch((err) => {
      dispatch(setError(err));
      dispatch(loginError(err.response?.data.message));
      dispatch(setAuthenticated(false));
    })
    .finally(() => dispatch(setLoading(false)));
};

export const checkToken = (doInit) => (dispatch) => {
  const token = localStorage.getItem("token");

  if (token) {
    dispatch(setLoading(true));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
    dispatch(doInit());
    dispatch(setAuthenticated(true));
    dispatch(setLoading(false));
  }
};

export const doInitAdmin = () => (dispatch) => {
  dispatch(getUser());
  dispatch(typeGroupsRequest());
  dispatch(stateTrainingChildren());
  dispatch(statusChildren());
  dispatch(stateSchedule());
  dispatch(invoiceState());
  dispatch(getSourcesClient());
  dispatch(fetchDiscountClient());
  dispatch(getStatusClient());
};

export const doInitTrainer = () => (dispatch) => {
  dispatch(getUser());
  /* dispatch(stateTrainingChildren());*/
};

export const doInitClient = () => (dispatch) => {
  dispatch(getUser());
};

export const getUser = () => async (dispatch) => {
  dispatch(setLoading(true));
  apiService
    .getUser()
    .then((data) => {
      if (!data) throw new TypeError("No User");
      dispatch(setUser(data));
      dispatch(setError(false));
      dispatch(setAuthenticated(true));
    })
    .catch(() => {
      dispatch(setAuthenticated(false));
      dispatch(setUser(null));
      dispatch(signOut());
    })
    .finally(() => dispatch(setLoading(false)));
};

const setError = (error) => {
  return {
    type: "SET_ERROR",
    payload: error,
  };
};

const setAuthenticated = (status) => {
  return {
    type: "SET_AUTHENTICATED",
    payload: status,
  };
};

const setUser = (user) => {
  return {
    type: "SET_USER",
    payload: user,
  };
};

const setLoading = (loading) => {
  return {
    type: "SET_LOADING",
    payload: loading,
  };
};

export const loadingUser = (bool) => {
  return {
    type: "LOADING_USER",
    payload: bool,
  };
};

export const signOut = () => (dispatch) => {
  dispatch(setAuthenticated(false));
  dispatch(setUser(null));
  apiService.logout();
  localStorage.removeItem("token");
  axios.defaults.headers.common = {
    Authorization: "",
  };
};

export const userUpdate = (payload) => (dispatch) => {
  /*dispatch(loadingUser(true));*/
  if (payload.phone) {
    payload.phone = payload.phone.replace(/\D+/g, "");
  }

  return apiService.updateUser(payload).then(() => {
    dispatch(getUser());
    /*dispatch(loadingUser(false));*/
  });
};
export const userResetPassword = (email) => (dispatch) => {
  apiService
    .resetPasswordUser(email)
    .then(() => {})
    .catch((err) => {
      dispatch(loginError(err.response.data.message));
    });
};

export const userUpdatePassword = (payload) => (dispatch) => {
  apiService
    .updatePasswordUser(payload)
    .then(() => {
      dispatch(messageErrorPassword(true));
    })
    .catch((err) => {
      dispatch(messageErrorPassword(err.response.data.message));
    });
};
